import { erpAxios } from '..';

const getApplicationDocuments = async (id) => {
  const { data } = await erpAxios.get(`/dokumenti/application/${id}`);
  return data;
};

export default getApplicationDocuments;
